import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function HeroSection() {
  return <section id="home" className="relative min-h-screen flex items-center justify-center pt-20 overflow-hidden bg-petrol" data-id="element-147">
      {/* Tech-forward circuit background */}
      <div className="absolute inset-0 bg-circuit opacity-50 pointer-events-none" data-id="element-148"></div>

      {/* Turquoise glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-turquoise/10 rounded-full blur-[120px] pointer-events-none" data-id="element-149"></div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 md:px-12 text-center" data-id="element-150">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-151">
          <span className="inline-flex items-center gap-2 py-1 px-3 rounded-full bg-petrol-light border border-turquoise/30 text-turquoise text-xs font-semibold tracking-widest uppercase mb-6 shadow-[0_0_10px_rgba(0,212,170,0.1)]" data-id="element-152">
            <span className="w-1.5 h-1.5 rounded-full bg-turquoise animate-pulse" data-id="element-153"></span>
            Agencia de Crecimiento Digital
          </span>

          <h1 className="text-5xl md:text-7xl font-bold leading-tight mb-6" data-id="element-154">
            Anclamos tu Marca al{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-turquoise to-turquoise-light" data-id="element-155">
              Éxito Digital.
            </span>
          </h1>
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="text-lg md:text-xl text-silver max-w-3xl mx-auto mb-10 leading-relaxed" data-id="element-156">
          Diseño Web de Élite, Landing Pages de Alta Conversión y Media Buying
          para Profesionales que lideran su sector.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-157">
          <a href="https://wa.me/50672642898" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto flex items-center justify-center gap-2 bg-turquoise hover:bg-turquoise-hover text-petrol font-bold text-base px-8 py-4 rounded transition-all hover:shadow-[0_0_20px_rgba(0,212,170,0.4)]" data-id="element-158">
            Solicitar Auditoría Gratis
            <ArrowRightIcon className="w-5 h-5" data-id="element-159" />
          </a>
          <a href="#servicios" className="w-full sm:w-auto flex items-center justify-center px-8 py-4 rounded text-white font-medium border border-petrol-lighter hover:bg-petrol-light hover:border-turquoise/30 transition-colors" data-id="element-160">
            Ver Servicios
          </a>
        </motion.div>
      </div>
    </section>;
}